// Simple browser-compatible EventBus
class EventBus {
  constructor() {
    this.events = {};
  }
  on(event, listener) {
    if (!this.events[event]) this.events[event] = [];
    this.events[event].push(listener);
  }
  off(event, listener) {
    if (!this.events[event]) return;
    this.events[event] = this.events[event].filter(l => l !== listener);
  }
  emit(event, ...args) {
    if (!this.events[event]) return;
    this.events[event].forEach(listener => {
      if (typeof listener === 'function') {
        listener(...args);
      }
    });
  }
}
const eventBus = new EventBus();
export default eventBus;



// WEBPACK FOOTER //
// ./src/helpers/EventBus/index.js